export default __webpack_public_path__ + "static/automobile-gluestick-5ca7ad0ab95c68bee3cc27cf7fc57b84.gif";